var _defs, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationSeats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.031,
    height: 202.566,
    viewBox: "0 0 236.031 202.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ah{fill:#d9e9fe;}.a{opacity:0.532;}.b{fill:#f5f5f5;}.c{fill:#e6e6e6;}.d{fill:#ebebeb;}.e{fill:#f0f0f0;}.f{fill:#e0e0e0;}.g{fill:#1b2327;}.h{fill:#263238;}.i{fill:#0a8591;}.j,.o,.q{opacity:0.1;}.ac,.ad,.k,.n,.o,.q,.r{fill:#fff;}.aa,.ah,.k,.u{opacity:0.2;}.l{fill:#0da3b2;}.m{fill:#407bff;}.n{opacity:0.4;}.ab,.o,.u{isolation:isolate;}.p{opacity:0.3;}.s{fill:#097782;}.t{fill:#e2915a;}.v{fill:#222;}.w{fill:#ff8b7b;}.x{fill:#efa471;}.y{fill:#ffb27d;}.z{fill:#a02724;}.ab,.ad{opacity:0.5;}.ac{opacity:0.7;}.ae{fill:#0c95a3;}.af{fill:#6d89d0;}.ag{fill:#45449f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1966.412,1474.2l-212.952-.077s-.131-.169-.37-.5c-.094-.131-.206-.286-.334-.466-.336-.476-.779-1.124-1.3-1.932-.2-.313-.417-.652-.64-1.012-1-1.611-2.2-3.686-3.433-6.159q-.462-.92-.928-1.916l-.039-.082c-.1-.217-.2-.439-.307-.662h0q-.227-.5-.452-1.007c-.552-1.252-1.1-2.577-1.624-3.969-.033-.088-.066-.175-.1-.263q-.549-1.463-1.064-3.024c-.029-.087-.058-.175-.087-.263-.04-.123-.079-.246-.119-.37-.034-.105-.067-.211-.1-.317q-.126-.4-.246-.8l-.024-.078c-.023-.074-.045-.15-.068-.224q-.377-1.265-.719-2.582-.165-.63-.318-1.271c-.447-1.849-.834-3.769-1.143-5.751q-.331-2.131-.536-4.357c0-.023,0-.048-.006-.071a64.886,64.886,0,0,1-.256-6.683,63.832,63.832,0,0,1,9.394-32.327,85.122,85.122,0,0,1,10.536-14.319,57.74,57.74,0,0,1,4.56-4.41c7.615-6.564,15.365-9.38,22.844-9.5.3,0,.6-.005.905,0,8.831.118,17.256,3.959,24.593,9.776,4.7,3.725,14.833,3.157,26.3-6.112a60.92,60.92,0,0,0,4.56-4.094,87.431,87.431,0,0,0,11.533-14.367q.355-.542.708-1.1,2.717-4.257,5.374-9.289c.034-.066.068-.131.1-.194q.833-1.568,1.753-3.026c13.867-22.038,41.869-25.6,64.444-14.52q2.321,1.139,4.561,2.484A60.176,60.176,0,0,1,1945.8,1341.4q1.277,1.462,2.468,3.026a59,59,0,0,1,5.893,9.483q.27.545.532,1.1c5.781,12.253,7.88,27.523,4.026,45.37C1950.885,1436.637,1982.543,1437.955,1966.412,1474.2Z",
    transform: "translate(-1739.244 -1281.242)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 188.929)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 116.748,
    cy: 6.818,
    rx: 116.748,
    ry: 6.818,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.05 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.357)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18.853,
    height: 20.069,
    transform: "translate(27.626 3.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.829,
    height: 20.069,
    transform: "translate(46.479 3.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 14.162,
    height: 23.164,
    transform: "translate(22.682)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.095,
    height: 23.164,
    transform: "translate(36.839)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 11.94,
    height: 20.069,
    transform: "translate(20.732 3.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.728,
    height: 20.069,
    transform: "translate(32.672 3.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 15.662,
    height: 16.673,
    transform: "translate(7.238 6.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.01,
    height: 16.673,
    transform: "translate(22.899 6.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 11.766,
    height: 19.244,
    transform: "translate(3.131 3.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.402,
    height: 19.244,
    transform: "translate(14.891 3.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 11.429,
    height: 16.673,
    transform: "translate(0 6.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 2.264,
    height: 16.673,
    transform: "translate(11.435 6.491)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 99.356,
    height: 5.809,
    transform: "translate(99.356 5.809) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.064 5.945)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M73.719,155.694h6.8l-4.95,7.474H73.719Z",
    transform: "translate(-72.74 -155.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.979,
    height: 7.474
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.538 5.945)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M200.428,155.694h6.8l-4.95,7.474h-1.846Z",
    transform: "translate(-199.449 -155.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.979,
    height: 7.474,
    transform: "translate(0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.015 51.21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M197.246,273.495h13.219l-.305-1.436c-1.41-3.8-8.638-3.8-8.638-3.8-1.79.1-3.542,1.779-4.041,4.125Z",
    transform: "translate(-139.67 -218.491)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.298 31.673)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M172.223,250.372h-12.06l1.582,13.886h13.281Z",
    transform: "translate(-154.214 -243.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M173.439,261.179h-.627v.157H150.284v-1.919H171.1l-2.8-13.886h-12.06l-.669-5.891a1.508,1.508,0,0,1,1.507-1.436H167.4a1.513,1.513,0,0,1,1.512,1.436Z",
    transform: "translate(-150.284 -238.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M175.026,264.258H161.745l-1.46-12.793-.122-1.093h12.06Z",
    transform: "translate(-154.215 -243.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M160.72,254.995l-.556-4.622h13.919l.971,4.622Z",
    transform: "translate(-154.215 -243.046)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.105 51.219)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M125.735,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,125.735,272.736Z",
    transform: "translate(-123.857 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M129.355,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,129.355,272.736Z",
    transform: "translate(-125.297 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M132.974,272.736H131.4a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.133a.3.3,0,0,1,.291.2l.445,1.522A.282.282,0,0,1,132.974,272.736Z",
    transform: "translate(-126.737 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M136.594,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,136.594,272.736Z",
    transform: "translate(-128.177 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M140.214,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,140.214,272.736Z",
    transform: "translate(-129.617 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M143.833,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.133a.3.3,0,0,1,.291.2l.445,1.522A.282.282,0,0,1,143.833,272.736Z",
    transform: "translate(-131.058 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M147.453,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.444,1.522A.281.281,0,0,1,147.453,272.736Z",
    transform: "translate(-132.498 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M151.073,272.736H149.5a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,151.073,272.736Z",
    transform: "translate(-133.938 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M154.693,272.736h-1.578a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.133a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,154.693,272.736Z",
    transform: "translate(-135.378 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M158.312,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.133a.3.3,0,0,1,.291.2l.444,1.522A.281.281,0,0,1,158.312,272.736Z",
    transform: "translate(-136.818 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M161.932,272.736h-1.577a.288.288,0,0,1-.3-.275V270.94a.288.288,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,161.932,272.736Z",
    transform: "translate(-138.258 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M165.551,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.133a.3.3,0,0,1,.291.2l.445,1.522A.282.282,0,0,1,165.551,272.736Z",
    transform: "translate(-139.698 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M169.171,272.736h-1.577a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.444,1.522A.281.281,0,0,1,169.171,272.736Z",
    transform: "translate(-141.139 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M172.791,272.736h-1.577a.288.288,0,0,1-.3-.275V270.94a.288.288,0,0,1,.3-.275h1.132a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,172.791,272.736Z",
    transform: "translate(-142.579 -270.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M176.411,272.736h-1.578a.289.289,0,0,1-.3-.275V270.94a.289.289,0,0,1,.3-.275h1.133a.3.3,0,0,1,.291.2l.445,1.522A.281.281,0,0,1,176.411,272.736Z",
    transform: "translate(-144.019 -270.665)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M156.99,273.588a1.262,1.262,0,0,1-1.313,1.2H123.044a1.258,1.258,0,0,1-1.313-1.2,1.151,1.151,0,0,1,.382-.849,1.365,1.365,0,0,1,.9-.349h32.665a1.483,1.483,0,0,1,.363.046A1.222,1.222,0,0,1,156.99,273.588Z",
    transform: "translate(-121.731 -271.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M156.99,273.588a1.262,1.262,0,0,1-1.313,1.2H123.044a1.258,1.258,0,0,1-1.313-1.2,1.151,1.151,0,0,1,.382-.849,1.365,1.365,0,0,1,.9-.349h32.665a1.483,1.483,0,0,1,.363.046A1.222,1.222,0,0,1,156.99,273.588Z",
    transform: "translate(-121.731 -271.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M171.517,273.618a1.262,1.262,0,0,1-1.313,1.2h-11.05a1.222,1.222,0,0,1-.911-1.146,1.19,1.19,0,0,1,.019-.215,1.16,1.16,0,0,1,.37-.634,1.554,1.554,0,0,1,.281-.2l.153-.07a1.441,1.441,0,0,1,.5-.087h11A1.222,1.222,0,0,1,171.517,273.618Z",
    transform: "translate(-136.258 -271.382)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.475)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M214.049,185.6h-3.334l-3.748,40.673H210.3a1.216,1.216,0,0,0,1.107-1.155l3.535-38.363A.975.975,0,0,0,214.049,185.6Z",
    transform: "translate(-158.013 -185.603)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M176.545,226.276H126.566a.975.975,0,0,1-.894-1.155l3.535-38.363a1.217,1.217,0,0,1,1.107-1.155h49.979a.975.975,0,0,1,.894,1.155l-3.535,38.363A1.217,1.217,0,0,1,176.545,226.276Z",
    transform: "translate(-125.666 -185.603)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M177.666,220.584H132.273l2.517-28.775h45.393Z",
    transform: "translate(-113.82 -188.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M175.674,221.407H130.943a2.072,2.072,0,0,1-2.1-2.3l2.5-28.6a2.558,2.558,0,0,1,2.5-2.3h44.731a2.072,2.072,0,0,1,2.1,2.3l-2.5,28.6A2.557,2.557,0,0,1,175.674,221.407Z",
    transform: "translate(-112.453 -186.642)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.453 3.737)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M177.666,220.584H132.273l2.517-28.775h45.393Z",
    transform: "translate(-132.273 -191.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M177.666,220.584H132.273l2.517-28.775h45.393Z",
    transform: "translate(-132.273 -191.809)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.364 1.588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M177.527,188.24,168.661,221.4h2.983l8.768-33.161Z",
    transform: "translate(-168.661 -188.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M185.172,188.24,176.305,221.4h5.916l8.768-33.161Z",
    transform: "translate(-171.703 -188.24)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.669)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M143.379,288.129h4.013l6.422,76.074a1.455,1.455,0,0,1-1.45,1.577h0a1.455,1.455,0,0,1-1.448-1.312Z",
    transform: "translate(-118.239 -281.063)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 119.658,
    height: 13.496,
    transform: "translate(4.708 6.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M272.955,287.35l-.466,13.383,21.484.011v-13.5Z",
    transform: "translate(-169.606 -280.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M111.1,287.248h-4.013l-.116,81.806a1.457,1.457,0,0,0,1.457,1.46h0a1.458,1.458,0,0,0,1.458-1.437Z",
    transform: "translate(-103.755 -280.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M271.212,287.248H267.2l-.116,81.806a1.458,1.458,0,0,0,1.458,1.46h0A1.458,1.458,0,0,0,270,369.077Z",
    transform: "translate(-167.456 -280.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M107.092,287.248l-.116,81.806a1.457,1.457,0,0,0,1.457,1.46h0a1.458,1.458,0,0,0,1.458-1.437l1.214-81.829Z",
    transform: "translate(-103.755 -280.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M271.212,287.248H267.2l-.116,81.806a1.458,1.458,0,0,0,1.458,1.46h0A1.458,1.458,0,0,0,270,369.077Z",
    transform: "translate(-167.456 -280.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M101.627,279.69h0c0-1.818.678-3.291,1.512-3.3H229.011c.834,0,1.51,1.478,1.512,3.3h0c0,1.818-.678,3.29-1.512,3.3H103.139C102.305,282.98,101.63,281.507,101.627,279.69Z",
    transform: "translate(-101.627 -276.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M101.627,279.69h0c0-1.818.678-3.291,1.512-3.3H229.011c.834,0,1.51,1.478,1.512,3.3h0c0,1.818-.678,3.29-1.512,3.3H103.139C102.305,282.98,101.63,281.507,101.627,279.69Z",
    transform: "translate(-101.627 -276.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M261.735,279.69h0c0-1.818.677-3.291,1.511-3.3h29.466c.834,0,1.51,1.478,1.512,3.3h0c0,1.818-.678,3.29-1.512,3.3H263.246C262.412,282.98,261.737,281.507,261.735,279.69Z",
    transform: "translate(-165.328 -276.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M303.486,287.248H307.5l6.423,76.6a1.455,1.455,0,0,1-1.45,1.576h0a1.454,1.454,0,0,1-1.448-1.313Z",
    transform: "translate(-181.939 -280.712)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.685 15.493)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M204.157,245.217c-9.6,0-13.328-8.727-13.372-8.831l.754-.311c.193.468,4.893,11.4,17.869,7.5,13.152-3.955,23.612-31.958,23.716-32.241l.765.282c-.431,1.169-10.708,28.668-24.246,32.739A19,19,0,0,1,204.157,245.217Z",
    transform: "translate(-190.785 -211.333)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.661 10.726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.759)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 19.236,
    height: 44.277
  })), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 19.236,
    height: 44.277,
    transform: "translate(13.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 19.236,
    height: 44.277
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.22 5.509)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M248.8,216.5a3.935,3.935,0,1,1-3.934-3.934A3.934,3.934,0,0,1,248.8,216.5Z",
    transform: "translate(-240.933 -212.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M248.266,217.6a2.353,2.353,0,1,1-2.353-2.353A2.353,2.353,0,0,1,248.266,217.6Z",
    transform: "translate(-241.978 -213.63)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.187 18.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M248.135,235.41a1.967,1.967,0,1,1-1.967-1.967A1.967,1.967,0,0,1,248.135,235.41Z",
    transform: "translate(-244.2 -233.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M247.867,235.959a1.177,1.177,0,1,1-1.177-1.177A1.177,1.177,0,0,1,247.867,235.959Z",
    transform: "translate(-244.723 -233.976)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.851 11.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 0.607,
    height: 7.059
  })), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 16.412,
    height: 16.412,
    transform: "translate(1.412 25.646)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.277 26.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M248.847,260.808a.967.967,0,1,1-.966-.967A.966.966,0,0,1,248.847,260.808Z",
    transform: "translate(-240.37 -252.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M245.678,255.07c-.1-2.342,5.543-7.22,1.782-7.22s-6.221,2.652-6.076,4.2S245.678,255.07,245.678,255.07Z",
    transform: "translate(-238.167 -247.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M243.569,262.171c-2.254.644-8.317-3.7-7.437-.044s4.033,5.428,5.5,4.926S243.569,262.171,243.569,262.171Z",
    transform: "translate(-236.045 -252.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M250.259,259.449c1.914,1.352,2.329,8.8,4.627,5.822s1.7-6.545.388-7.376S250.259,259.449,250.259,259.449Z",
    transform: "translate(-241.7 -251.777)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.793 43.737)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.442 124.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M164.447,400.911l5.412-1.612-1.642-12.789-6.658,2.37Z",
    transform: "translate(-160.811 -382.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M160.316,382.8l7.026-2.613,1.058,9.2-6.237,1.747Z",
    transform: "translate(-160.316 -380.184)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.456 138.648)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M171.817,406.2l-6.168,1.675a.471.471,0,0,0-.32.552l.933,5.877a1.047,1.047,0,0,0,1.212.894c2.136-.626,3.137-1.048,5.847-1.785,1.67-.452,5.484-1.538,7.82-1.966s1.862-3.163.834-3.232c-4.618-.285-7.27-.841-9.125-1.866A1.4,1.4,0,0,0,171.817,406.2Z",
    transform: "translate(-165.323 -404.53)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.467)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M180.792,406.114a.746.746,0,0,0-.007-.746.47.47,0,0,0-.386-.287c-.731-.1-2.042,1.33-2.187,1.5a.142.142,0,0,0,.01.141.12.12,0,0,0,.117.074,7.172,7.172,0,0,0,1.482-.149A1.556,1.556,0,0,0,180.792,406.114Zm-.45-.775a.239.239,0,0,1,.182.151.471.471,0,0,1,.033.476c-.194.32-.914.49-1.947.562C179.154,405.968,179.957,405.284,180.342,405.34Z",
    transform: "translate(-177.912 -404.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M178.207,406.114a2.928,2.928,0,0,0,.745-2.374.5.5,0,0,0-.557-.275.635.635,0,0,0-.5.311c-.431.665.089,2.218.093,2.285a.149.149,0,0,0,.1.09l.059,0A.1.1,0,0,0,178.207,406.114Zm.221-2.389c.193-.02.28.055.285.129a2.676,2.676,0,0,1-.54,1.9,2.922,2.922,0,0,1-.061-1.832.4.4,0,0,1,.249-.182Z",
    transform: "translate(-177.723 -403.454)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.864 73.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M109.051,295.3s32.06,2.705,31.273,16.627c-.645,11.4-2.334,8.3.985,42.187l-8.066.446s-8.2-27.719-7.1-38.732c-9.037,0-29.726.793-32.732-7.361a36.249,36.249,0,0,1-2.142-12.919Z",
    transform: "translate(-91.267 -295.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M158.491,392.038l10.539-1.8-.173-4.662L157.947,388Z",
    transform: "translate(-117.797 -331.217)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.012 126.009)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M197.978,403.426l5.1-2.419-3.574-12.389-6.218,3.358Z",
    transform: "translate(-192.005 -384.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M191.157,386.117l6.545-3.654,2.449,8.929-5.9,2.678Z",
    transform: "translate(-191.157 -382.463)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.304 139.205)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M206.046,407.5l-5.841,2.6a.472.472,0,0,0-.232.594l1.82,5.666a1.046,1.046,0,0,0,1.334.7c2.015-.944,2.94-1.514,5.507-2.655,1.582-.7,5.184-2.357,7.429-3.137s1.357-3.41.331-3.321c-4.608.422-7.314.278-9.3-.452A1.4,1.4,0,0,0,206.046,407.5Z",
    transform: "translate(-199.946 -405.579)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.942)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M214.843,406.527a.745.745,0,0,0-.121-.736.469.469,0,0,0-.425-.224c-.737.014-1.815,1.626-1.933,1.812a.142.142,0,0,0,.031.138.119.119,0,0,0,.127.055,7.132,7.132,0,0,0,1.442-.373A1.557,1.557,0,0,0,214.843,406.527Zm-.563-.7a.239.239,0,0,1,.2.122.469.469,0,0,1,.105.465c-.143.345-.829.623-1.838.852C213.2,406.632,213.891,405.834,214.28,405.83Z",
    transform: "translate(-211.826 -404.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M212.222,407.058a2.928,2.928,0,0,0,.374-2.46.5.5,0,0,0-.592-.186.631.631,0,0,0-.447.384c-.325.723.425,2.179.44,2.245a.148.148,0,0,0,.108.075l.058-.013A.1.1,0,0,0,212.222,407.058Zm-.146-2.4c.187-.05.285.012.3.084a2.675,2.675,0,0,1-.244,1.957,2.922,2.922,0,0,1-.34-1.8.394.394,0,0,1,.218-.217Z",
    transform: "translate(-211.475 -404.379)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.051 73.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M125.324,295.3c.211,0,35.941,3.677,35.986,15.8.077,20.043,5.8,43.018,5.8,43.018l-7.062,3.5s-12.3-24.907-12.111-40.531c-9.829-2.82-35.257,1.918-38.263-6.229-2.462-6.664-1.131-15.553-1.131-15.553Z",
    transform: "translate(-108.184 -295.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M191.6,395.1l9.465-4.259-.761-3.876-9.983,3.447Z",
    transform: "translate(-140.863 -331.771)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.078 30.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M104.817,224.27c-1.042,1.971-1.912,3.873-2.788,5.852s-1.661,3.963-2.4,6-1.394,4.13-1.946,6.3a33.407,33.407,0,0,0-1.067,6.907,14.3,14.3,0,0,0,.4,4.074,9.107,9.107,0,0,0,.951,2.328,7.249,7.249,0,0,0,.857,1.157l.261.282c.147.135.306.284.46.4a5.041,5.041,0,0,0,.832.516,6.75,6.75,0,0,0,1.358.511,9.009,9.009,0,0,0,1.122.223,15.6,15.6,0,0,0,1.948.1,27.379,27.379,0,0,0,3.456-.21,65.2,65.2,0,0,0,12.577-2.923l-.748-3.566c-4.08.28-8.245.588-12.157.569-.971-.049-1.918-.052-2.8-.142a8.155,8.155,0,0,1-1.161-.206c-.317-.073-.585-.2-.49-.191a.725.725,0,0,1,.175.1,1.085,1.085,0,0,1,.172.143h0a1.108,1.108,0,0,1-.052-.111,2.973,2.973,0,0,1-.163-.579,8.946,8.946,0,0,1-.064-2.142,28.252,28.252,0,0,1,1.086-5.381c.531-1.894,1.188-3.731,1.9-5.6s1.469-3.729,2.294-5.583,1.686-3.712,2.53-5.456Z",
    transform: "translate(-96.604 -224.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M132.608,270.709l4.355-2.168,1.895,4.694s-5.055,1.812-6.03.47Z",
    transform: "translate(-110.929 -241.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M143.228,269.563l1.78,3.164-3.27.456-1.895-4.694Z",
    transform: "translate(-113.807 -241.863)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.237 34.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M131.744,234.951c.812,2.04-.081-.271.815,1.705s1.791,3.92,2.737,5.864a112.62,112.62,0,0,0,6.4,11.512c.639.947,1.279,1.886,2,2.826.358.473.754.941,1.177,1.42.23.243.415.467.685.717l.384.371.217.2a5.438,5.438,0,0,0,2.1,1.113,9.277,9.277,0,0,0,1.24.262,12.864,12.864,0,0,0,2.059.083,26.578,26.578,0,0,0,3.543-.352,65.045,65.045,0,0,0,12.676-3.594l.035-4.5c-4.138.5-8.366,1.03-12.343,1.2a27.09,27.09,0,0,1-2.814-.039,7.108,7.108,0,0,1-1.119-.179,1.471,1.471,0,0,1-.345-.128c-.039,0,0-.045.173.064a.828.828,0,0,1,.172.128s-.045-.058-.064-.077l-.179-.2c-.115-.115-.256-.307-.39-.46-.263-.333-.531-.691-.8-1.081-.53-.761-1.049-1.605-1.56-2.462-1.024-1.714-1.976-3.537-2.91-5.379s-1.829-3.722-2.711-5.615c-1.759-3.773-1.736-3.381-3.373-7.186Z",
    transform: "translate(-131.744 -231.168)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.37 20.838)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M187.164,266.982l5.8-1.208,2.275,6.288s-6.691.671-7.923-1.149Z",
    transform: "translate(-187.164 -265.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M201.2,267.363l2.207,4.255-4.338.444-2.275-6.288Z",
    transform: "translate(-190.994 -265.774)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.021)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M136.294,194.912a14.8,14.8,0,0,0,1.552,3.625,2.26,2.26,0,0,1-1.914.108Z",
    transform: "translate(-118.028 -182.855)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.108 10.257)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M135.5,197.22a1.609,1.609,0,0,1-.452.076c-1.127.024-2.071-1.161-2.1-2.642s.861-2.7,1.988-2.731a1.84,1.84,0,0,1,1.507.8,3.182,3.182,0,0,1,.6,1.838A2.649,2.649,0,0,1,135.5,197.22Zm-.928-4.934a2.338,2.338,0,0,0-1.325,2.361c.028,1.315.834,2.368,1.795,2.347a1.288,1.288,0,0,0,.365-.061,2.35,2.35,0,0,0,1.327-2.361,2.875,2.875,0,0,0-.536-1.663,1.544,1.544,0,0,0-1.26-.684A1.3,1.3,0,0,0,134.576,192.286Z",
    transform: "translate(-132.949 -191.922)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M110.806,201.291l3.153,3.292,4.305,4.488a5.117,5.117,0,0,0-.752,1.714c-.384,1.344-.712,2.331,2.2,3.64a1.755,1.755,0,0,1,1.091,1.553c-.005.829-.651,1.73-3.538,1.779a13.075,13.075,0,0,1-7.736-2.576c-1.1-.779-.99-1.494-.3-2.627C111.261,209.347,111.209,204.849,110.806,201.291Z",
    transform: "translate(-107.197 -185.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M137.677,194.039c.035.443-.123.817-.353.835s-.445-.327-.479-.77.123-.817.353-.835S137.642,193.6,137.677,194.039Z",
    transform: "translate(-118.389 -182.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M126.463,193.821a8.036,8.036,0,0,1-4.705,5.325,7.483,7.483,0,0,1-2.431.555,6.871,6.871,0,0,1-5.443-2.218c-2.737-2.9-2.557-6.185-2.737-11.766a7.767,7.767,0,0,1,10.751-7.483C127.294,180.523,127.81,188.821,126.463,193.821Z",
    transform: "translate(-108.164 -175.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M127.1,213.015a7.483,7.483,0,0,1-2.431.555l-.095-.04.53-1.036S125.435,213.377,127.1,213.015Z",
    transform: "translate(-113.511 -189.85)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.063 9.949)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 0.301,
    height: 8.629,
    transform: "translate(0 0.29) rotate(-74.467)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.954,188.133c-.979,1.649-2.173,3.264-2.441,5.163-.113.8-6.17,1.983-7.625.464a13.3,13.3,0,0,1-2.932-5.522,14.384,14.384,0,0,1-.4-7.657,6.776,6.776,0,0,1,2.321-3.752,4.117,4.117,0,0,1,4.233-.526,8.873,8.873,0,0,1,13.7,8.2.8.8,0,0,1-.187.53.847.847,0,0,1-.69.119l-3.447-.413c-.431-.052-.964-.193-1.04-.621-.049-.273-.337-1.673-.35-1.88Z",
    transform: "translate(-106.197 -174.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M122.693,194.238a5.106,5.106,0,0,0,1.967,3.073c1.307.946,2.624-.4,2.611-1.983-.013-1.423-.948-3.392-2.431-3.706S122.385,192.715,122.693,194.238Z",
    transform: "translate(-112.738 -181.529)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M114.779,173.2a1.85,1.85,0,0,1,1.795,1.206c.167.432.331,1.469-.151,1.693A15.651,15.651,0,0,0,114.779,173.2Z",
    transform: "translate(-109.612 -173.193)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M92.7,222.621c.479-1.279,2.717-2.558,4.093-2.558H97.7a49.634,49.634,0,0,1,5.481.352,97.645,97.645,0,0,1,10.872,1.829c1.65.435,3.243.985,4.509,1.458,1.611.639,2.558,1.068,2.558,1.068s-1.766,11.757-2.68,23.436c-.508,6.5-.3,12.953-.461,17.391H90.7c-.94-5.334-.792-9.985-.868-19.616C89.788,240.2,90.727,227.884,92.7,222.621Z",
    transform: "translate(-89.831 -191.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M134.623,249.453c-.2,2.449-.415,5.021-.639,7.591-3.2-4.668-4.969-17.44-4.969-17.44Z",
    transform: "translate(-105.421 -199.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M137.578,228.469c3.907,2.2,7.737,13.458,7.737,13.458l-8.947,6.751c-3.415-3.23-8.409-11.242-8.953-14.447C126.539,229.313,131.317,224.965,137.578,228.469Z",
    transform: "translate(-104.743 -194.68)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.612 129.951)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M157.184,426.8a2.782,2.782,0,1,0,2.782-2.782,2.782,2.782,0,0,0-2.782,2.782Z",
    transform: "translate(-110.121 -423.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M84.588,426.8a2.782,2.782,0,1,1-2.782-2.782,2.782,2.782,0,0,1,2.782,2.782Z",
    transform: "translate(-79.024 -423.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M123.544,425.32a2.782,2.782,0,1,1-2.782-2.782,2.782,2.782,0,0,1,2.782,2.782Z",
    transform: "translate(-94.523 -422.538)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.31 123.921)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M124.035,417.9v-5.378H132a25.339,25.339,0,0,1,4.662.435l14.838,2.884a1.35,1.35,0,0,1-.3,2.673Z",
    transform: "translate(-93.631 -412.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M103.945,417.9v-5.378H95.971a25.284,25.284,0,0,0-4.662.435l-16.676,2.666a1.349,1.349,0,0,0,.3,2.673Z",
    transform: "translate(-73.541 -412.524)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.784 79.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.868,
    height: 28.406,
    transform: "translate(0 17.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.035,
    height: 18.137,
    transform: "translate(1.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M125.229,341.541l-7.035,1.771v-5.135h7.035Z",
    transform: "translate(-116.781 -338.177)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.456 53.241)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 3.575,
    height: 15.253
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac",
    width: 3.575,
    height: 15.253
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M106.367,285.875V219.567a8.71,8.71,0,0,0-2.973-6.552l-4.726-4.137a8.708,8.708,0,0,0-5.737-2.156H75.859L67.516,215.6v70.278Z",
    transform: "translate(-61.834 -206.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M148.517,316.871H109.57V329.7h45.291a4.6,4.6,0,0,0,3.965-6.952h0A11.974,11.974,0,0,0,148.517,316.871Z",
    transform: "translate(-78.565 -250.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M67.514,215.6V285.88h70.617a4.609,4.609,0,0,0,3.965-6.952,11.963,11.963,0,0,0-10.29-5.877H112.189a5.824,5.824,0,0,1-5.824-5.824v-47.66a8.687,8.687,0,0,0-2.974-6.549l-4.726-4.138a8.684,8.684,0,0,0-5.737-2.155H75.86Z",
    transform: "translate(-61.833 -206.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M96.93,285.875V219.567a8.71,8.71,0,0,0-2.973-6.552l-4.726-4.137a8.707,8.707,0,0,0-5.737-2.156H70.188a8.709,8.709,0,0,0-6.346,2.745l-3.4,3.618a8.708,8.708,0,0,0-2.363,5.964v60.188a6.639,6.639,0,0,0,6.639,6.639Z",
    transform: "translate(-58.079 -206.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M96.93,285.875V219.567a8.71,8.71,0,0,0-2.973-6.552l-4.726-4.137a8.707,8.707,0,0,0-5.737-2.156H70.188a8.709,8.709,0,0,0-6.346,2.745l-3.4,3.618a8.708,8.708,0,0,0-2.363,5.964v60.188a6.639,6.639,0,0,0,6.639,6.639Z",
    transform: "translate(-58.079 -206.721)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.596 49.624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M141.63,297.407a36.864,36.864,0,0,1,24.3,0,3.454,3.454,0,0,0,4.279-1.631h0c.729-1.541-.25-3.537-2.232-4.234a43.021,43.021,0,0,0-28.382,0c-1.983.691-2.961,2.693-2.232,4.234h0A3.46,3.46,0,0,0,141.63,297.407Z",
    transform: "translate(-137.124 -289.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M141.63,297.407a36.864,36.864,0,0,1,24.3,0,3.454,3.454,0,0,0,4.279-1.631h0c.729-1.541-.25-3.537-2.232-4.234a43.021,43.021,0,0,0-28.382,0c-1.983.691-2.961,2.693-2.232,4.234h0A3.46,3.46,0,0,0,141.63,297.407Z",
    transform: "translate(-137.124 -289.134)"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.286 125.222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.044 26.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M2654.777,1910.6s-4.717-5.5-.291-9c0,0,3.233-1.958,5.87-1.8,0,0-3.737,6.264-2.527,6.887s3.658-7.28,3.658-7.28,7.358-.713,9.725.425c0,0-6.29,5.147-4.965,5.454s8.118-4.746,8.118-4.746,6.848,1.165,6.483,5.343-2.725,5.467-3.762,5.356-7.1-2.427-7.236-1.577,3.52,3.626,6.077,3.756c0,0-4.827,5.326-8.037,3.788s-3.482-3.972-5.482-4.886-3.708-.911-2.882.02,4.446,1.838,5.589,3.861,2.17,3.388-1.149,2.889-8.716-2.929-8.953-5.711Z",
    transform: "translate(-2646.803 -1899.19)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.776)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M2673.938,1918.295s-18.6-.717-22.706,4.6a13.468,13.468,0,0,1-3.7,5.2l-.436,1.187s3.223-3.4,4.377-3.6C2651.469,1925.678,2649.665,1919.089,2673.938,1918.295Z",
    transform: "translate(-2643.258 -1918.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M2640.571,1945.088a11.679,11.679,0,0,0-4.27,8.227l.724.065s1.274-5.455,3.58-7.588S2640.571,1945.088,2640.571,1945.088Z",
    transform: "translate(-2636.302 -1935.255)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2562.376,1876.567s7.5-4.2,4-9.905c0,0-2.8-3.5-5.8-4.4,0,0,1.6,8.5,0,8.7s-1.1-9.605-1.1-9.605-7.9-3.8-11.006-3.5c0,0,4.9,8.3,3.3,8.1s-7.1-8.6-7.1-8.6-8.1-1.5-9.405,3.3.8,7.2,2,7.5,8.9.2,8.7,1.2-5.4,2.6-8.3,1.7c0,0,3.2,7.9,7.4,7.5s5.5-3,8.1-3.2,4.5.5,3.2,1.2-5.7.23-7.8,2.016-3.8,2.887.1,3.687,10.905.3,12.306-2.7Z",
    transform: "translate(-2534.852 -1857.135)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.113 5.025)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M2546.427,1871.277s21.01,6.8,23.412,14.408a15.961,15.961,0,0,0,2,7.3v1.5s-2.2-5.1-3.4-5.8C2568.438,1888.686,2573.141,1882.083,2546.427,1871.277Z",
    transform: "translate(-2546.427 -1871.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M2616.133,1930.69a13.858,13.858,0,0,1,1.392,10.91l-.834-.224s.81-6.6-.885-9.914S2616.133,1930.69,2616.133,1930.69Z",
    transform: "translate(-2590.719 -1908.979)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M2634.123,1849.036s-9.891-5.539-5.275-13.057c0,0,3.693-4.616,7.649-5.8,0,0-2.11,11.21,0,11.474s1.451-12.661,1.451-12.661,10.418-5.012,14.507-4.615c0,0-6.462,10.946-4.352,10.682s9.363-11.342,9.363-11.342,10.683-1.978,12.4,4.353-1.055,9.5-2.637,9.891-11.738.263-11.474,1.583,7.122,3.429,10.947,2.242c0,0-4.22,10.419-9.76,9.892s-7.253-3.957-10.682-4.221-5.936.66-4.221,1.583,7.517.3,10.287,2.656,5.012,3.806-.131,4.861-14.376.4-16.223-3.56Z",
    transform: "translate(-2627.621 -1823.421)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.278 6.624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M2672,1842.063s-27.7,8.968-30.862,18.991a21.044,21.044,0,0,1-2.637,9.628v1.978s2.9-6.726,4.484-7.649C2642.983,1865.012,2636.784,1856.307,2672,1842.063Z",
    transform: "translate(-2635.912 -1842.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M2633.805,1920.379a18.271,18.271,0,0,0-1.837,14.382l1.1-.3s-1.067-8.7,1.167-13.069S2633.805,1920.379,2633.805,1920.379Z",
    transform: "translate(-2631.219 -1891.76)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M2609.826,1976.122a19.375,19.375,0,0,0,19.376-19.376H2590.45A19.375,19.375,0,0,0,2609.826,1976.122Z",
    transform: "translate(-2570.697 -1909.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M2618.878,1975.973a19.388,19.388,0,0,1-21.783-19.227h4.814A19.378,19.378,0,0,0,2618.878,1975.973Z",
    transform: "translate(-2574.981 -1909.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M2628.984,2009.718H2589.7a2.39,2.39,0,0,1,2.39-2.39h34.506a2.39,2.39,0,0,1,2.39,2.39Z",
    transform: "translate(-2570.211 -1941.987)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ah",
    width: 39.829,
    height: 0.594,
    transform: "translate(19.116 47.37)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSeats);
export default __webpack_public_path__ + "static/media/illustration-seats.a375ff7b6af99f26d1566ce862e91df2.svg";
export { ForwardRef as ReactComponent };